import { DialogContent, DialogContentProps } from '@mui/material';

import useResponsive from '../../hooks/useResponsive';

function ModalBody(props: DialogContentProps) {
    const { sx, children } = props;
    const { isMobile } = useResponsive();

    return (
        <DialogContent
            sx={{
                gridArea: 'body',
                minWidth: isMobile ? '100%' : '450px',
                overflowY: 'auto',
                overflowX: 'hidden',
                flex: 1,
                p: 2.5,
                pt: 0,
                ...sx,
            }}
        >
            {children}
        </DialogContent>
    );
}

export default ModalBody;
